import React, { useEffect } from 'react';

const Estimating = () => {
  useEffect(() => {
    // Redirect to the handover index file in the public folder
    window.location.href = '/handover/index.html';
  }, []);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      minHeight: '100vh',
      fontSize: '16px',
      color: '#666'
    }}>
      Redirecting to estimating...
    </div>
  );
};

export default Estimating;
